// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"0e101e14","156":"305644b7","224":"ea0f2318","682":"412c35cf","828":"4ec4f00f"}[chunkId] + ".chunk.css";
};